const DATE_FORMATS = {
  DAY_MONTH_YEAR: "dd.MM.yyyy",
  ISO_SHORT: "yyyy-MM-dd",
  LOCAL_MONTH_YEAR: "LLLL yyyy",
  DATE_TIME: "dd.MM.yy, HH:mm"
};
export {
  DATE_FORMATS
};
